import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import { FaFacebook } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { BsTelegram } from "react-icons/bs";
import { IoIosArrowUp } from "react-icons/io";
import { ImLinkedin } from "react-icons/im";
import {Link} from "react-scroll";
import LogoHuawey from "../../img/logo_huawey.png";
import LogoWomo from "../../img/womo_white.png";
import LogoWiT from "../../img/logo_wit.png";
import React from "react";

import DeloUa from "../../img/delo_ua.svg";
import MMR from "../../img/mmr.png";



function Footer() {
    return (
        <>
            <div className="fixed bottom-4 right-4 bg-[#000744] text-white p-2 rounded-[6px] z-30 cursor-pointer">
                <Link to="top" smooth={true} offset={-70} duration={500}>
                    <IoIosArrowUp />
                </Link>
            </div>
            <footer className="py-10 bg-center bg-no-repeat">
                <div className="container w-full sm:max-w-screen-md max-w-[90%] mx-auto relative z-30 pb-10">
                    <ScrollAnimation animateIn="animate__fadeInUp">
                    <div
                        className="flex sm:gap-10 gap-6 justify-center items-center">
                        <a href="http://www.huawei.com/ua" target="_blank">
                            <img src={LogoHuawey} alt="Huawei"
                                 className="w-[100px]"/>
                        </a>
                        <a href="https://womo.ua/" target="_blank">
                            <img src={LogoWomo} alt="Womo"
                                 className="w-[80px]"/>
                        </a>
                        <a href="http://www.womenintech.com.ua" target="_blank">
                            <img src={LogoWiT} alt="Logo HRWS"
                                 className="w-[100px]"/>
                        </a>
                    </div>
                    </ScrollAnimation>
                </div>

                <div className="w-full h-0.5 bg-white/10 z-30 relative mb-6"/>

                <div
                    className="container mx-auto text-white relative z-20 flex justify-center">
                    {/*<div>*/}
                    {/*    <ScrollAnimation animateIn="animate__fadeInUp">*/}
                    {/*        <h4 className="text-[18px] font-medium mb-[16px]">Участь і партнерство</h4>*/}
                    {/*        <p className="font-light text-[#f2f2f2] text-[16px] mb-[10px]">Iрина</p>*/}
                    {/*        <a href="tel:+380674084524"*/}
                    {/*           className="block font-light text-[#f2f2f2] text-[16px] mb-[10px] phone_partner_clk">*/}
                    {/*            +38 (067) 408 45 24</a>*/}
                    {/*        <a href="mailto:i.pyrog@ekonomika.ua"*/}
                    {/*           className="block font-light text-[#f2f2f2] text-[16px] mb-[10px] phone_partner_clk_1">*/}
                    {/*            i.pyrog@ekonomika.ua</a>*/}
                    {/*    </ScrollAnimation>*/}
                    {/*</div>*/}
                    {/*<div>*/}
                    {/*    <ScrollAnimation animateIn="animate__fadeInUp">*/}
                    {/*        <h4 className="text-[18px] font-medium mb-[16px]">Питання щодо участі</h4>*/}
                    {/*        /!*<p className="font-light text-[#f2f2f2] text-[16px] mb-[10px]">З питань придбання квитків*!/*/}
                    {/*        /!*    звертатися*!/*/}
                    {/*        /!*    в службу продажів бізнес/медіа бюро ekonomika+</p>*!/*/}
                    {/*        <p className="font-light text-[#f2f2f2] text-[16px] mb-[10px]">Яна</p>*/}
                    {/*        <a href="tel:+380672230179"*/}
                    {/*           className="block font-light text-[#f2f2f2] text-[16px] mb-[10px] phone_sell_clk">*/}
                    {/*            +38 (067) 223 01 79</a>*/}
                    {/*        <a href="mailto:tickets@ekonomika.ua"*/}
                    {/*           className="block font-light text-[#f2f2f2] text-[16px] mb-[10px] email_sell_clk">*/}
                    {/*            tickets@ekonomika.ua</a>*/}
                    {/*        <p className="font-light text-[#f2f2f2] text-[16px] mb-[10px]">Світлана</p>*/}
                    {/*        <a href="tel:+30968369409"*/}
                    {/*           className="block font-light text-[#f2f2f2] text-[16px] mb-[10px] phone_sell_clk_1">*/}
                    {/*            +38 096 836 94 09</a>*/}
                    {/*    </ScrollAnimation>*/}
                    {/*</div>*/}
                    {/*<div>*/}
                    {/*    <ScrollAnimation animateIn="animate__fadeInUp">*/}
                    {/*        <h4 className="text-[18px] font-medium mb-[16px]">Реклама</h4>*/}
                    {/*        <p className="font-light text-[#f2f2f2] text-[16px] mb-[10px]">Тетяна</p>*/}
                    {/*        <a href="tel:+380672327292"*/}
                    {/*           className="block font-light text-[#f2f2f2] text-[16px] mb-[10px] phone_adv_clk">*/}
                    {/*            +38 (067) 232 72 92</a>*/}
                    {/*        <a href="mailto:t.svyatnenko@ekonomika.ua"*/}
                    {/*           className="block font-light text-[#f2f2f2] text-[16px] mb-[10px] phone_adv_clk_1">*/}
                    {/*            t.svyatnenko@ekonomika.ua</a>*/}
                    {/*    </ScrollAnimation>*/}
                    {/*</div>*/}
                    <div className="text-center">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h4 className="text-[18px] font-medium mb-9">Слідкуйте за анонсами</h4>
                            <div className="flex gap-6 mb-9 justify-between">
                                <a href="https://facebook.com/womenintechukraine" className="text-2xl"
                                   target="_blank"><FaFacebook/></a>
                                <a href="https://instagram.com/womenintech.ukraine" className="text-2xl"
                                   target="_blank"><RiInstagramFill/></a>
                                <a href="https://www.linkedin.com/company/women-in-tech-ukraine" className="text-2xl"
                                   target="_blank"><ImLinkedin/></a>
                            </div>
                            <h4 className="text-[18px] font-medium mb-9">Інформаційні партнери:</h4>
                            <div className="flex gap-6 mb-9 justify-center">
                                <a href="https://mmr.ua/" className="text-2xl"
                                   target="_blank">
                                    <img src={MMR} alt="MMR" className="h-10 w-auto" />
                                   </a>
                                <a href="https://delo.ua/" className="text-2xl"
                                   target="_blank">                                    <img src={DeloUa} alt="Delo.ua" className="h-10 w-auto" />
</a>
                            </div>
                            <p className="mb-6"><a href="/privacy-policy">Політика Приватності</a></p>
                            <p className="text-center">
                                Питання стосовно роботи сайту <br />
                                <a href="mailto:welcome@womo.ua"
                                className="block font-light text-[#f2f2f2] text-[16px] mb-[10px] phone_adv_clk_1">
                                welcome@womo.ua</a></p>
                        </ScrollAnimation>
                    </div>
                </div>
                <div className="bg-[#af00a9]/90 absolute top-0 left-0 w-full h-full z-10"></div>
            </footer>
        </>
    )
}

export default Footer;